

























import Vue from 'vue'

import { ProductCardModel } from '@/search/types'
import ProductCard from '@/common/components/productCard/ProductCard.vue'
import ProductCardGender from '@/common/components/productCard/ProductCardGender.vue'
import ProductCardTextInfo from '@/common/components/productCard/ProductCardTextInfo.vue'
import ProductCardDescription from '@/common/components/productCard/ProductCardDescription.vue'
import ProductCardFunction from '@/common/components/productCard/ProductCardFunction.vue'

export default Vue.extend({
  components: {
    ProductCard,
    ProductCardTextInfo,
    ProductCardDescription,
    ProductCardFunction,
    ProductCardGender
  },
  props: {
    product: {
      type: Object as () => ProductCardModel,
      required: true
    },
    extendQueries: {
      type: Object,
      default: () => { return {} }
    },
    useNativeLazy: {
      type: Boolean,
      default: false
    }
  },
  data(): {
    psi: number | null
    productUrl: string
  } {
    return {
      psi: this.product.skuDetails[0].psi,
      productUrl: this.product.url
    }
  },
  computed: {
    isMobileView(): boolean {
      return window.innerWidth < 1024
    },
    extendQueriesStr(): string {
      const result = Object.keys(this.extendQueries).map(key => `${key}=${this.extendQueries[key]}`)
      return result.join('&')
    }
  },
  created() {
    if (this.extendQueriesStr) {
      this.productUrl += `?${this.extendQueriesStr}`
    }
  },
  methods: {
    onUpdatePsi(psi: number | null) {
      this.psi = psi
      this.productUrl = `${this.product.url}?${this.psi ? `&psi=${this.psi}` : ''}${this.extendQueriesStr ? `&${this.extendQueriesStr}` : ''}`
    }
  }
})
